'use client';

import { useLingui } from '@lingui/react';
import { Box, Stack, Typography } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import type { LanguageCodeT, ToolsCollaboratorsAnalyzeTalentsT } from '@prismo-io/schemas';
import { type FC, useMemo } from 'react';
type Props = {
  category: ToolsCollaboratorsAnalyzeTalentsT['config'][number];
  activeStepId: string;
};
export const CategoryItem: FC<Props> = props => {
  const {
    category,
    activeStepId
  } = props;
  const {
    i18n
  } = useLingui();
  const current = useMemo(() => category.steps.filter(step => step.checked).length, [category]);
  const total = useMemo(() => category.steps.length, [category]);
  const progress = useMemo(() => current / total * 100, [current, total]);
  const label = useMemo(() => category.title[i18n.locale as LanguageCodeT], [i18n.locale, category.title]);
  const isActive = useMemo(() => category.steps.map(step => step.id).includes(activeStepId), [category.steps, activeStepId]);
  return <Stack direction="column" gap="4px" alignItems="center" justifyContent="space-between" data-sentry-element="Stack" data-sentry-component="CategoryItem" data-sentry-source-file="category-item.tsx">
      <Box display={{
      none: 'none',
      md: 'block'
    }} component="div" height="5px" width="5px" borderRadius={9_999} bgcolor={progress > 0 || isActive ? 'primary.main' : 'background.grayLight'} data-sentry-element="Box" data-sentry-source-file="category-item.tsx" />
      <Typography display={{
      none: 'none',
      md: 'block'
    }} textAlign="center" fontSize="10px" color={isActive ? 'primary.main' : undefined} fontWeight={isActive ? 'bold' : undefined} data-sentry-element="Typography" data-sentry-source-file="category-item.tsx">
        {label}
      </Typography>
      <LinearProgress sx={{
      height: '8px',
      borderRadius: 1_000_000,
      width: '100%',
      backgroundColor: 'background.grayLight',
      [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 1_000_000,
        backgroundImage: 'gradient.main'
      }
    }} variant="determinate" value={progress} data-sentry-element="LinearProgress" data-sentry-source-file="category-item.tsx" />
    </Stack>;
};